import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { ClearButton } from '../../../../components/button/ClearButton';
import { Routes } from '../../../../utils/app-constants';
import { formatCurrency } from '../../../../utils/currency-formatter';
import { toShortDate } from '../../../../utils/date-utils';
import { PickupStatusMetadata } from '../../../../transportation/models/enums/pickup-status';
import { PickupSummary } from '../../../../transportation/models/pickups/pickup-summary';

// #region Component Props

interface IProps {
    pickup              : PickupSummary;
    viewLoadsheet       : any;
}

// #endregion

export const PickupRow = (props: IProps) => (
    <tr key={props.pickup.id}>
        <td>
            <NavLink to={Routes.SHIPPING_PICKUP_EDIT_WITH_ID.formattify(props.pickup.id)}>
                { props.pickup.id }
            </NavLink>
        </td>
        <td>
            <span className={ "text-uppercase shipment-status-color " + PickupStatusMetadata[props.pickup.status].class }>
                { PickupStatusMetadata[props.pickup.status].display }
            </span>
        </td>
        <td>{ `${props.pickup.dealerName} [${props.pickup.dealerId}]` }</td>
        <td>{ props.pickup.pickupTime ? toShortDate(props.pickup.pickupTime.local) : 'Not Set' }</td>
        <td>{ formatCurrency(props.pickup.amount) }</td>  
        <td className="action-cell-icons">
 
            <ClearButton
                id={'shipmentrow-' + props.pickup.id }
                text="Paperwork"
                classes="action"
                onBtnClick={ () => { props.viewLoadsheet(props.pickup.dealerId, props.pickup.id); } }
                icon="la-file-pdf-o" />
        </td>                              
    </tr>
);
